;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .factory('TextShapesService', textShapesService)

  /* @ngInject */
  function textShapesService ($q) {
    // For now we are using an static array of text shapes
    // in the future it will come from the backend
    var oTextShapesService = {
      aTextShapes: [
        {
          imgSrc: '/assets/img/components/texts/text-37.png',
          filePath: '/assets/shapes/texts/text-37.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-36.png',
          filePath: '/assets/shapes/texts/text-36.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-35.png',
          filePath: '/assets/shapes/texts/text-35.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-34.png',
          filePath: '/assets/shapes/texts/text-34.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-33.png',
          filePath: '/assets/shapes/texts/text-33.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-32.png',
          filePath: '/assets/shapes/texts/text-32.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-31.png',
          filePath: '/assets/shapes/texts/text-31.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-30.png',
          filePath: '/assets/shapes/texts/text-30.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-29.png',
          filePath: '/assets/shapes/texts/text-29.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-28.png',
          filePath: '/assets/shapes/texts/text-28.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-27.png',
          filePath: '/assets/shapes/texts/text-27.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-26.png',
          filePath: '/assets/shapes/texts/text-26.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-25.png',
          filePath: '/assets/shapes/texts/text-25.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-24.png',
          filePath: '/assets/shapes/texts/text-24.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-23.png',
          filePath: '/assets/shapes/texts/text-23.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-22.png',
          filePath: '/assets/shapes/texts/text-22.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-21.png',
          filePath: '/assets/shapes/texts/text-21.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-20.png',
          filePath: '/assets/shapes/texts/text-20.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-19.png',
          filePath: '/assets/shapes/texts/text-19.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-18.png',
          filePath: '/assets/shapes/texts/text-18.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-17.png',
          filePath: '/assets/shapes/texts/text-17.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-16.png',
          filePath: '/assets/shapes/texts/text-16.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-15.png',
          filePath: '/assets/shapes/texts/text-15.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-14.png',
          filePath: '/assets/shapes/texts/text-14.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-13.png',
          filePath: '/assets/shapes/texts/text-13.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-12.png',
          filePath: '/assets/shapes/texts/text-12.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-11.png',
          filePath: '/assets/shapes/texts/text-11.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-10.png',
          filePath: '/assets/shapes/texts/text-10.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-9.png',
          filePath: '/assets/shapes/texts/text-9.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-8.png',
          filePath: '/assets/shapes/texts/text-8.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-7.png',
          filePath: '/assets/shapes/texts/text-7.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-1.png',
          filePath: '/assets/shapes/texts/text-1.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-2.png',
          filePath: '/assets/shapes/texts/text-2.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-3.png',
          filePath: '/assets/shapes/texts/text-3.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-4.png',
          filePath: '/assets/shapes/texts/text-4.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-5.png',
          filePath: '/assets/shapes/texts/text-5.svg'
        },
        {
          imgSrc: '/assets/img/components/texts/text-6.png',
          filePath: '/assets/shapes/texts/text-6.svg'
        }
      ]
    }

    oTextShapesService.fnSetTextShapes = function (aTextShapes) {
      oTextShapesService.aTextShapes = aTextShapes
    }

    oTextShapesService.fnGetTextShapes = function () {
      // from now we are returning static data
      // in the future we should get the data from server
      // and return a Promise
      return $q.resolve(oTextShapesService.aTextShapes)
    }

    return oTextShapesService
  }
})()
